// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3qoLZ","rootCenter":"LoadMoreObserver_rootCenter__31AQS","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__35H3G"};